import { ListEnum } from '@v4/common/utils/data-layer';

export default {
    leadFormCtas() {
        return JSON.parse(this.fetchedData.form.ctas);
    },
    pageAbbr() {
        return (
            {
                submodel: ListEnum.LIST_VDP_PAGE,
                version: ListEnum.LIST_VIP_PAGE,
                versions: ListEnum.LIST_VLP_PAGE,
                'single-offer': ListEnum.LIST_VOP_PAGE,
            }[this.fetchedData.id] || ''
        );
    },
};
